//---------------------------------------------------------------------
// React, MUI, and other third-party modules imports
//---------------------------------------------------------------------
import React from 'react';
import { useContext } from 'react';
// import { useState, useEffect, useContext, useCallback } from 'react';
import { makeStyles } from '@material-ui/core';
import VerifiedUserIcon from '@material-ui/icons/VerifiedUser';

//---------------------------------------------------------------------
// Common helpers and constants imports
//---------------------------------------------------------------------
// import { unsubscribeRealtimeUpdates } from '../system/firebase';
import { LayoutContext } from '../../common/contexts';
import { setClassNameInDefns } from '../../common/definitionHelper';
import { COMPANY_NAME_MISSING } from '../../common/constants';

//---------------------------------------------------------------------
// Page specific helpers and constants imports
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Common components imports
//---------------------------------------------------------------------
// import AfitdTypography from '../../common/elemental/AfitdTypography';

//---------------------------------------------------------------------
// Page specific components imports
//---------------------------------------------------------------------
// import SubComponent1Example from './SubComponent1Example';

//---------------------------------------------------------------------
// Utilities (clsx, lodash, date-fns, etc.) imports
//---------------------------------------------------------------------
// import cx from 'clsx';
import _get from 'lodash/get';
import AfitdAvatar from '../../common/elemental/AfitdAvatar';

//---------------------------------------------------------------------
// CSS
//---------------------------------------------------------------------
const useStyles = (params = {}) => {
    const { isBannerVisible, isLogoVisible } = params;

    return makeStyles(theme => ({
        root: {
            textAlign: 'center',
        },
        bannerContainer: {
            height: '350px',
            width: '100%',
            borderRadius: '10px',
            background: '#d4d4d4',
            display: isBannerVisible ? 'block' : 'none',
        },
        banner: {
            height: '350px',
            width: '100%',
            borderRadius: '10px',
        },
        logoTitleContainer: {
            textAlign: 'center',
            position: 'relative',
            ...(isBannerVisible ? { bottom: '64px' } : {}),
        },
        profilePictureContainer: {
            height: '90px',
            width: '90px',
            borderRadius: '10px',
            background: '#d4d4d4',
            margin: 'auto',
            display: isLogoVisible ? 'block' : 'none',
        },
        companyProfilePic: {
            width: 90,
            height: 90,
            border: '1px solid #D5D7DD',
        },
        profileTitle: {
            fontSize: '26px',
            fontWeight: 'bold',
            marginTop: isBannerVisible || isLogoVisible ? '30px' : 0,
        },
        verified: {
            color: '#1D8A8B',
            fontSize: '28px',
            position: 'relative',
            margin: '0 8px',
            top: '4px',
        },
    }));
};

//---------------------------------------------------------------------
// Get definitions
//---------------------------------------------------------------------
const getDefns = params => {
    const { classes, props } = params;
    const { brandData } = props;

    const profilePicUrl = _get(brandData, 'profilePicUrl');
    const bannerUrl = _get(brandData, 'bannerUrl');

    const defns = {
        companyProfilePic: {
            variant: 'rounded',
            src: profilePicUrl,
        },
        banner: {
            src: bannerUrl,
        },
    };

    // Automatically inject className for matching keys
    setClassNameInDefns(defns, classes);

    return defns;
};

//---------------------------------------------------------------------
// Helper functions
//---------------------------------------------------------------------

//---------------------------------------------------------------------
// Component
//---------------------------------------------------------------------
const CompanyShowcase = props => {
    //---------------------------------------------------------------------
    // From context and other hooks
    //---------------------------------------------------------------------
    // const appContext = useContext(AppContext);
    // const { currentEmployer } = appContext;

    const layoutContext = useContext(LayoutContext);
    const { profileData, isBannerVisible, isLogoVisible /*, setSnackbarMessage, setSnackbarErrorMessage*/ } = layoutContext;

    //---------------------------------------------------------------------
    // From props
    //---------------------------------------------------------------------
    const companyName = _get(props, 'companyInfoData.companyName', COMPANY_NAME_MISSING);
    const isEmpBadge = _get(props, 'companyInfoData.isEmpBadge');

    //---------------------------------------------------------------------
    // Local states
    //---------------------------------------------------------------------
    // const [isDirty, setIsDirty] = useState(false);

    //---------------------------------------------------------------------
    // Side effects
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Derived
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // useCallback / Event handlers
    //---------------------------------------------------------------------

    //---------------------------------------------------------------------
    // Definitions
    //---------------------------------------------------------------------
    const classes = useStyles({ isBannerVisible, isLogoVisible })();
    const defns = getDefns({ classes, props, profileData });

    //---------------------------------------------------------------------
    // Render
    //---------------------------------------------------------------------

    return (
        <div {...defns.root}>
            <div {...defns.bannerContainer}>
                <img {...defns.banner} alt="" />
            </div>
            <div {...defns.logoTitleContainer}>
                <div {...defns.profilePictureContainer}>
                    <AfitdAvatar {...defns.companyProfilePic}>?</AfitdAvatar>
                </div>
                <div {...defns.profileTitle}>
                    {companyName}
                    {isEmpBadge && <VerifiedUserIcon {...defns.verified} />}
                </div>
            </div>
        </div>
    );
};

export default CompanyShowcase;
